import { FC } from 'react';
import useSidebarContext from '@/hooks/useSidebarContext';
import { decodeJWT } from '@/utils/decodeJWT';
import { getAccessToken } from '@/utils/auth';
import { useTranslation } from 'react-i18next';
import { getprivateMenuItems } from '../menuItems';
import styles from './DesktopMenu.module.scss';
import MenuItem from '../MenuItem/MenuItem';

const DesktopMenu: FC = () => {
  const { isSidebarActive, isSidebarAnchored } = useSidebarContext();

  const isSidebarOpen = isSidebarActive || isSidebarAnchored;

  const { t: menuTranslates } = useTranslation('menu');
  const accessToken = getAccessToken();
  const decodedJWTTokenData = accessToken ? decodeJWT(accessToken) : null;
  const accessPages = decodedJWTTokenData?.permisos.split(';') || [];
  const privateMenuItems = getprivateMenuItems(menuTranslates, accessPages);

  return (
    <nav className={styles.desktopMenu}>
      <ul>
        {privateMenuItems.map((item) => {
          const { label, icon, to, items } = item;

          return (
            <MenuItem
              key={label}
              label={label}
              icon={icon}
              to={to}
              isSidebarOpen={isSidebarOpen}
              items={items}
            />
          );
        })}
      </ul>
    </nav>
  );
};

export default DesktopMenu;
